import photoDefault from '@/assets/images/no_user.jpeg'
import noPhotoDefault from '@/assets/images/no-photo.png'
import WebchatLogo from '@/assets/images/channels/webchat.png'
import TelegramLogo from '@/assets/images/channels/telegram.png'
import WhatsappLogo from '@/assets/images/channels/whatsapp.png'
import InstagramLogo from '@/assets/images/channels/instagram.png'
import MessengerLogo from '@/assets/images/channels/messenger.png'

export const extension_img = ['jpeg', 'jpg', 'png', 'gif', 'bmp']
export const extension_document = ['doc', 'docx', 'xls', 'xlsx', 'pdf']
export const extension_audio = ['oppus']
export const extension_video = ['mp4']
export const ui_avatar = 'https://ui-avatars.com/api/'

export function formateImage(img) {
    /* const base_url = window.location.origin; */
    if (img && typeof img === 'string') {
        if (img.indexOf('http') >= 0) {
            return img
        } else {
            return  'https://www.chatmix.com.br/storage/' + img
        }
    }
    return photoDefault
}

export function fixedUserPhoto(e) {
    e.target.src = photoDefault
}
export function fixedNoPhoto(e) {
    e.target.src = noPhotoDefault
}
export function getImageUrl(img) {
    return img
    // return new URL(`../${img}`, import.meta.url).href
}

export function validateSizeImage(size, maxsize) {
    if (!size || !maxsize) {
        return true
    }

    if (parseInt(size / 1000000) >= maxsize) {
        return true
    }
    return false
}
export function getNameAndTypeFile(file) {
    if (!file) { return { name: '', type: '' } }
    const isFile = file.split('.')
    const extension = isFile.pop()
    const name = isFile.join('-')
    return { name, type: getTypeFile(extension) }
}

export function getTypeFile(extension) {
    if (extension_document.includes(extension)) {
        return 'document'
    }
    if (extension_img.includes(extension)) {
        return 'image'
    }
    if (extension_video.includes(extension)) {
        return 'video'
    }
    if (extension_audio.includes(extension)) {
        return 'audio'
    }
    return 'none'
}
export function getIcon(type) {
    if (!type) return fixedNoPhoto
    switch (type.toLowerCase()) {
        case 'webchat':
            return WebchatLogo
        case 'telegram':
            return TelegramLogo
        case 'instagram':
            return InstagramLogo
        case 'instagram_v2':
            return InstagramLogo
        case 'messengerlogo':
            return MessengerLogo
        case 'messenger':
            return MessengerLogo
        case 'whatsapp':
            return  WhatsappLogo
        default:
            return fixedNoPhoto
    }
}